import Vue from 'vue'
import './ssr-hook'
import './fetch-hook'
import createRouter from './create-router'
import createSrv from './create-srv'
import createStore from './create-store'
import createEventer from './create-eventer'
import createHooks from './create-hooks'
import createGlobals from './create-globals'
import createCssVars from './css-vars'
import assignPlugin from './assign-plugin'
import runPlugins from './run-plugins'
import VueMeta from 'vue-meta'
import Api from './api'

Vue.config.productionTip = false
Vue.use(assignPlugin)
Vue.use(VueMeta, { refreshOnceOnNavigation: true })
Vue.use(Api)

export default function createApp({
	ssrContext,
	storesProviders,
	routesProviders,
	routerOptions,
	pluginsRunners,
	AppComponent,
	autoloaderComponents,
	window,
} = {}) {
	const options = {}
	options.ssr = ssrContext
	options.window = window
	options.apis = {}
	options.mixins = []

	createGlobals(options)
	createEventer(options)
	createSrv(options)
	createCssVars(options)

	if (storesProviders) {
		createStore(storesProviders, options)
	}

	if (routesProviders) {
		createRouter(routesProviders, routerOptions, options)
	}

	if (pluginsRunners) {
		runPlugins(pluginsRunners, options)
	}

	if (autoloaderComponents) {
		createHooks(autoloaderComponents, options)
	}

	// let _vuemixin = Vue.mixin;
	// Vue.mixin = (obj, key) => {
	// 	if(!_mixins[key]) _mixins[key] = true
	// 	return _vuemixin(obj)
	// }

	options.render = (h) => h(AppComponent)

	Vue._loaded = true
	return new Vue(options)
}
